import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { User, Mail, Star, LayoutGrid, FileText, ChevronLeft, Building2 } from 'lucide-react';
import { getProcesos } from '../api';

const etapas = ['Nuevos Postulantes', 'Hunting', 'Posibles', 'Entrevista Consultora', 'Entrevista Psicologica', 'Terna', 'Oferta', 'Contratado'];

const ProcesoDetalle = () => {
  const { id } = useParams();
  const [proceso, setProceso] = useState(null);
  const [activeTab, setActiveTab] = useState('Nuevos Postulantes');
  const [selectedCandidato, setSelectedCandidato] = useState(null);
  const [statusTab, setStatusTab] = useState('Calificados'); // Calificados / Descalificados

  useEffect(() => {
    const fetchProcesoAsync = async () => {
      try {
        const res = await getProcesos();
        // Buscar el proceso espefício o si no tirar 404 (Acá para rápido filtramos sobre el global)
        const proc = res.data.find(p => p.id === id);
        setProceso(proc);
      } catch(err) {
        console.error(err);
      }
    };
    fetchProcesoAsync();
  }, [id]);

  if (!proceso) return <div className="p-8 flex justify-center text-gray-500">Cargando detalles del proceso...</div>;

  // Filtrar candidatos por etapa seleccionada y en la pestaña de calificados (para la demo asumimos todos calificados)
  const filteredCandidates = proceso.Candidatos.filter(c => c.etapa_actual === activeTab);

  return (
    <div className="flex flex-col h-full bg-gray-50">
      {/* Header específico del Proceso */}
      <div className="bg-white px-8 py-4 border-b border-gray-200">
        <Link to="/procesos" className="flex items-center text-xs font-bold text-gray-400 hover:text-[#00a99d] mb-2 uppercase tracking-wider transition">
          <ChevronLeft size={14} /> Volver a Procesos Activos
        </Link>
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold text-[#00a99d] tracking-tight">{proceso.titulo}</h1>
            <div className="flex items-center gap-4 mt-2 text-sm text-gray-500 font-medium">
              <span className="flex items-center gap-1"><Building2 size={14}/> {proceso.Cliente ? proceso.Cliente.nombre : 'Cliente No Asignado'}</span>
            </div>
          </div>
          
          <div className="flex gap-2">
            <button className="bg-white border rounded px-3 py-1 flex justify-center items-center gap-1 text-xs text-gray-600 hover:bg-gray-50 font-bold uppercase"><LayoutGrid size={14}/> Proceso</button>
            <button className="bg-[#00a99d] border-[#00a99d] text-white rounded px-4 py-1 flex justify-center items-center gap-2 text-xs hover:opacity-90 font-bold uppercase shadow-sm">
              + Nuevo Candidato
            </button>
          </div>
        </div>

        {/* Cintas de Etapas (Top Tabs) */}
        <div className="flex gap-2 mt-6 overflow-x-auto pb-2 custom-scrollbar">
          {etapas.map(etapa => {
            const num = proceso.Candidatos.filter(c => c.etapa_actual === etapa).length;
            const isActive = activeTab === etapa;
            return (
              <button 
                key={etapa} 
                onClick={() => setActiveTab(etapa)}
                className={`flex-1 min-w-[150px] p-3 text-center border-t-4 bg-gray-50 transition-colors
                  ${isActive ? 'border-[#00a99d] bg-white shadow-sm' : 'border-gray-200 hover:bg-white'}
                `}
              >
                <div className={`text-xl font-bold ${num > 0 ? (isActive ? 'text-[#00a99d]' : 'text-gray-700') : 'text-gray-300'}`}>
                  {num || '-'}
                </div>
                <div className="text-[10px] font-bold text-gray-400 uppercase mt-1">{etapa}</div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Área Dividida Inferior (Master - Detail) */}
      <div className="flex flex-1 overflow-hidden">
        
        {/* Panel Izquierdo: Lista de Candidatos */}
        <div className="w-[380px] bg-white border-r border-gray-200 flex flex-col h-full overflow-hidden">
          {/* Sub-tabs Calificados / Descalificados */}
          <div className="flex border-b border-gray-100">
            <button 
              className={`flex-1 py-3 text-xs font-bold uppercase border-b-2 transition-colors ${statusTab === 'Calificados' ? 'border-[#00a99d] text-[#00a99d]' : 'border-transparent text-gray-400 hover:text-gray-600'}`}
              onClick={() => setStatusTab('Calificados')}
            >
              Calificados
            </button>
            <button 
              className={`flex-1 flex items-center justify-center gap-2 py-3 text-xs font-bold uppercase border-b-2 transition-colors ${statusTab === 'Descalificados' ? 'border-[#00a99d] text-[#00a99d]' : 'border-transparent text-gray-400 hover:text-gray-600'}`}
              onClick={() => setStatusTab('Descalificados')}
            >
              Descalificados <span className="bg-gray-400 text-white rounded px-1.5 py-0.5 text-[9px]">0</span>
            </button>
          </div>

          {/* Lista scrolleable */}
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            {filteredCandidates.length === 0 ? (
              <div className="text-center text-sm text-gray-400 mt-10">No hay candidatos en esta etapa.</div>
            ) : (
              filteredCandidates.map(c => (
                <div 
                  key={c.id} 
                  onClick={() => setSelectedCandidato(c)}
                  className={`border rounded-lg p-3 cursor-pointer transition-all flex items-start gap-3
                    ${selectedCandidato?.id === c.id ? 'border-[#00a99d] bg-emeral-green/5 shadow-md shadow-emeral-green/10' : 'border-gray-100 bg-white hover:border-gray-300'}
                  `}
                >
                  <input type="checkbox" className="mt-1.5 border-gray-300 rounded text-[#00a99d] focus:ring-[#00a99d]" onClick={(e) => e.stopPropagation()} />
                  
                  <div className="w-10 h-10 rounded-sm bg-gray-100 flex items-center justify-center shrink-0 border border-gray-200 overflow-hidden">
                     {c.foto_url ? (
                       <img src={c.foto_url} alt="" className="w-full h-full object-cover" />
                     ) : (
                       <User size={20} className="text-[#00a99d]" />
                     )}
                  </div>

                  <div className="flex-1 overflow-hidden">
                    <h4 className="text-sm font-bold text-gray-800 truncate">{c.nombre}</h4>
                    <div className="flex gap-0.5 text-yellow-400 my-1">
                      {[1,2,3,4,5].map(star => <Star key={star} size={10} fill={star <= c.rating ? 'currentColor' : 'none'} className={star > c.rating ? 'text-gray-300' : ''} />)}
                    </div>
                    <div className="text-xs text-gray-500 truncate flex items-center gap-1">
                      <Mail size={10}/> {c.email}
                    </div>
                    <div className="flex gap-1 mt-2 flex-wrap">
                      <span className="text-[9px] bg-blue-50 text-blue-500 px-1.5 py-0.5 rounded font-bold">#postulacion_web</span>
                      {c.cv_url && <span className="text-[9px] bg-green-50 text-green-600 px-1.5 py-0.5 rounded font-bold border border-green-100 flex items-center gap-1"><FileText size={8}/> PDF</span>}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Panel Derecho: Detalles del Candidato */}
        <div className="flex-1 p-6 flex flex-col bg-gray-50/50">
          {!selectedCandidato ? (
            <div className="flex-1 border-2 border-dashed border-gray-200 rounded-xl flex items-center justify-center text-gray-400 bg-gray-50/50">
              <span className="font-medium">Elija un candidato de la lista izquierda para ver sus detalles.</span>
            </div>
          ) : (
             <div className="flex flex-col h-full">
                {/* Visualizador de CV Incrustado (iframe para PDF) superior a Emeral */}
                <div className="bg-white rounded-t-xl border border-gray-200 flex-1 overflow-hidden flex flex-col shadow-sm">
                  <div className="bg-gray-800 text-white p-2 px-4 flex justify-between items-center">
                     <span className="text-xs font-bold flex items-center gap-2"><FileText size={14}/> Visor de Documento</span>
                     <div className="flex gap-4 text-xs font-medium text-gray-300">
                        {selectedCandidato.cv_url ? (
                          <a href={`http://localhost:5000${selectedCandidato.cv_url}`} target="_blank" rel="noreferrer" className="text-white hover:underline flex items-center gap-1">Descargar Original</a>
                        ) : 'Sin documento adjunto'}
                     </div>
                  </div>
                  {/* Visor */}
                  <div className="flex-1 bg-gray-200 flex items-center justify-center relative overflow-hidden">
                     {selectedCandidato.cv_url ? (
                        <iframe 
                          src={`http://localhost:5000${selectedCandidato.cv_url}#toolbar=0`} 
                          title="CV" 
                          className="w-full h-full border-none bg-white"
                        />
                     ) : (
                        <div className="text-gray-400 text-sm flex flex-col items-center gap-2">
                           <FileText size={40} className="text-gray-300"/>
                           No hay archivo PDF para visualizar
                        </div>
                     )}
                  </div>
                </div>
                
                {/* Metadatos Inferiores (Como en Emeral) */}
                <div className="mt-4 flex gap-6 text-xs text-gray-500 font-medium">
                  <span className="flex items-center gap-1">
                    <input type="checkbox" checked={!!selectedCandidato.cv_url} readOnly className="rounded text-[#00a99d] border-gray-300"/>
                    El perfil tiene CV
                  </span>
                  <span className="flex items-center gap-1">
                    <input type="checkbox" checked={false} readOnly className="rounded text-[#00a99d] border-gray-300"/> 
                    Ha sido contactado vía mensajes
                  </span>
                  <span className="flex items-center gap-1">
                    <input type="checkbox" checked={false} readOnly className="rounded text-[#00a99d] border-gray-300"/> 
                    La postulación tiene video
                  </span>
                </div>
             </div>
          )}
        </div>
        
      </div>
    </div>
  );
};

export default ProcesoDetalle;
